module.exports = __webpack_public_path__ + "static/media/aircraftbg.ea2d7f36.jpg";